import React from 'react'

import { AdvancedFilterControl } from 'features/views/ListView/ListHeader/Filters/Advanced/AdvancedFiltersFilterControl'

import { useToolbarActionsFiltersState } from './hooks/useToolbarActionsFiltersState'

type ToolbarActionsFiltersProps = {}

export const ToolbarActionsFilters: React.FC<ToolbarActionsFiltersProps> = () => {
    const { onClick, filterCount, isActive } = useToolbarActionsFiltersState()

    return (
        <AdvancedFilterControl
            size="xs"
            isActive={isActive}
            onClick={onClick}
            filterCount={filterCount}
        />
    )
}
